export default __webpack_public_path__ + "static/media/about-sm.1ecddc96.jpeg";